// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:06:37

export default {
  "id": "count-master-match-color-run",
  "slug": "count-master-match-color-run",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c170407bb6754be4a08fbc0a0d696611-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c170407bb6754be4a08fbc0a0d696611/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Count Master Match Color Run",
      "description": "Count Master: Match Color Run is a colorful running game where you lead a group of little characters in a color-matching race! In this exciting arcade challenge, collect characters of the same color to grow your team. Merge them for a bigger squad, aiming for the highest score. Avoid hammers, spikes, etc. Collect characters of the same color to expand your team.",
      "instructions": "Mouse click or tap to play",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "parkour",
        "run",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "数王颜色跑酷",
      "description": "颜色大师：匹配跑酷是一款色彩丰富的跑酷游戏，你将带领一群小角色进行颜色匹配比赛！在这场令人兴奋的街机挑战中，收集相同颜色的角色来壮大你的队伍。将他们合并成更大的队伍，争取获得最高分。避开锤子、刺等障碍。收集相同颜色的角色以扩充你的队伍。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "冒险"
      ],
      "tags": [
        "跑酷",
        "奔跑",
        "小人物"
      ]
    },
    "zh-TW": {
      "title": "數位大師比賽色彩跑",
      "description": "Count Master: 適色奔跑是一款色彩繽紛的跑步遊戲，您將帶領一群小角色進行適色競賽！在這場刺激的電子遊戲挑戰中，收集相同顏色的角色來擴大您的隊伍。合併他們以形成更大的隊伍，目標是獲得最高分數。避免鐵錘、釘子等障礙物。收集相同顏色的角色以擴展您的隊伍。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "冒險"
      ],
      "tags": [
        "躲避術",
        "奔跑",
        "小人立像"
      ]
    },
    "zh-HK": {
      "title": "數獨大師配對跑色",
      "description": "Count Master: 遊戲顏色跑是一個色彩繽紛的跑步遊戲，你將帶領一群小角色進行顏色匹配賽跑！在這個刺激的街機挑戰中，收集同顏色的角色來擴充你的隊伍。將他們合併以形成更大的隊伍，目標是獲得最高分數。避免鐵錘、釘子等障礙物。收集同顏色的角色來擴大你的隊伍。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "冒險"
      ],
      "tags": [
        "跳躍戰術",
        "奔跑",
        "瘦人"
      ]
    },
    "ja": {
      "title": "カウントマスター マッチ カラーラン",
      "description": "カウントマスター：マッチカラー・ランは、色を合わせるランニングゲームで、色合いで仲間を増やし、最高得点を目指す！このスリル満点のアーケード挑戦では、同じ色のキャラクターを集め、チームを成長させましょう。それらを統合してより大きなチームを目指して、ハンマーや棘などに避けながら色合いのキャラクターを集め、チームを拡大してください。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "パルクール",
        "走る",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "카운트 마스터 매치 컬러 런",
      "description": "카운트 마스터: 매치 컬러 러닝은 색상을 맞추는 러닝 게임으로, 작은 캐릭터들 그룹을 이끌고 색상 맞추기 경주를 즐길 수 있습니다! 이 흥미진진한 아케이드 도전에서 같은 색상의 캐릭터를 수집하여 팀을 커져 나가세요. 더 큰 부대로 합쳐져 더 높은 점수를 목표로하세요. 망치, 날카로운 돌 등을 피해주세요. 같은 색상의 캐릭터를 수집하여 팀을 확장하세요.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "모험"
      ],
      "tags": [
        "파크러",
        "달리기",
        "스틱맨"
      ]
    },
    "fr": {
      "title": "Maître du Compte Course aux Couleurs",
      "description": "Count Master : Course de couleur est un jeu de course coloré où vous guidez un groupe de petits personnages dans une course de correspondance de couleurs ! Dans ce challenge d'arcade captivant, collectez des personnages de la même couleur pour agrandir votre équipe. Fusionnez-les pour former une plus grande squad, en visant le plus haut score. Évitez les marteaux, les pointes, etc. Collectez des personnages de la même couleur pour agrandir votre équipe.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "parkour",
        "course",
        "stickman"
      ]
    }
  }
};
